import React from 'react';
import {
	Col,
	FormGroup,
	FormControl,
	ControlLabel
} from 'react-bootstrap';

import DatePicker from 'react-datepicker';

import RequiredMark from './RequiredMark';


const DayPicker = props => {
	return (
		<Col sm={props.sm || 12}>
			<FormGroup controlId='fromDay'>
				<ControlLabel style={props.labelFontWeight ? { fontWeight: props.labelFontWeight } : null}>{props.showRequiredMark ? <RequiredMark /> : null}{props.outerLabel}</ControlLabel>
				<FormControl componentClass='div' style={{ height: 36 }}>
					{
						props.showTimeSelect ?
							<DatePicker
								id={props.id || ''}
								disabled={props.disabled}
								placeholderText={!props.disabled ? 'Pick a date here' : ''}
								className='work-log-day-picker'
								showTimeSelect={true}
								timeFormat='HH:mm'
								timeIntervals={10}
								timeCaption='time'
								dateFormat='YYYY-MM-DD HH:mm'
								onChange={(date) => {
									props.onChange(date, props.dayStateName);
								}}
								selected={props.dayValue} />
							:
							<DatePicker
								disabled={props.disabled}
								placeholderText={!props.disabled ? 'Pick a date here' : ''}
								className='work-log-day-picker'
								dateFormat='YYYY-MM-DD'
								onChange={(date) => {
									props.onChange(date, props.dayStateName);
								}}
								selected={props.dayValue} />
					}

				</FormControl>
			</FormGroup>
		</Col>
	);
};

export default DayPicker;


// WEBPACK FOOTER //
// ./src/commonComponents/DayPicker.jsx